<div class="h-[calc(100vh-48px)] overflow-y-auto hide-scrollbar p-4">
  <div class="mb-4 flex justify-between items-center gap-x-2">
    <app-accounting-processes></app-accounting-processes>
    <button
      (click)="openDialog$.next(undefined)"
      icon="tuiIconPlus"
      size="s"
      tuiButton
    >
      Загрузить
    </button>
  </div>

  <tui-loader [overlay]="true" [showLoader]="!!(loading$ | async)">
    <table
      *tuiLet="(items$ | async) ?? [] as items"
      tuiTable
      class="journal-table w-full cursor-pointer"
      [columns]="columns"
    >
      <thead>
        <tr tuiThGroup>
          @for (header of tableHeaders; track header.value) {
            <th tuiTh>{{ header.name }}</th>
          }
          <th tuiTh></th>
        </tr>
      </thead>
      <tbody tuiTbody>
        @for (item of items; track item.id) {
          <tr
            tuiDropdownContext
            #dropdown="tuiDropdown"
            [tuiDropdown]="contextMenu"
            [tuiDropdownOpen]="false"
            appOnDropdownOpen="selected"
            tuiTr
            (dblclick)="openDialog$.next(item); dropdown.toggle(false)"
          >
            @for (header of tableHeaders; track header.value) {
              <td *tuiCell="header.value" tuiTd>
                @switch (header.value) {
                  @case ('date') {
                    {{ item.date | date: 'dd.MM.yyyy' }}
                  }
                  @case ('cost') {
                    {{ item.cost | number: '1.2-2' | spaceNumber }}
                  }
                  @default {
                    {{ item[header.value] }}
                  }
                }
              </td>
            }
            <ng-template #contextMenu>
              <tui-data-list
                role="menu"
                tuiDataListDropdownManager
                class="context-menu"
              >
                <button
                  (click)="
                    getSourceFile$.next(item.id!); dropdown.toggle(false)
                  "
                  tuiOption
                >
                  Скачать исходный файл
                </button>
                <button
                  (click)="
                    downloadExcel$.next(item.id!); dropdown.toggle(false)
                  "
                  tuiOption
                >
                  Скачать Excel
                </button>
                @if (item.groupId) {
                  <button
                    (click)="downloadGroupExcel$.next(item.groupId)"
                    tuiOption
                  >
                    Скачать группу файлов в Excel
                  </button>
                }
              </tui-data-list>
            </ng-template>
          </tr>
        } @empty {
          <tr>
            <td
              [attr.colspan]="columns.length"
              class="text-center py-10 text-gray-500"
            >
              Нет инвойсов
            </td>
          </tr>
        }
      </tbody>
    </table>
  </tui-loader>
</div>
